import React from 'react'
import { Box, makeStyles } from '@material-ui/core'
import { useParams } from 'react-router-dom'
import InfographicNavigation from '../components/InfographicNavigation'
import { EditInfographicBlockForm } from './components/EditInfographicBlockForm'

const useStyles = makeStyles(() => ({
  container: {
    padding: '1rem',
    display: 'flex',
    flex: '1',
    flexDirection: 'column'
  }
}))

const InfographicBlocksDetailsView = () => {
  const classes = useStyles()
  const params = useParams()

  return (
    <div className={classes.container}>
      <InfographicNavigation />
      <Box mt={2}>
        <EditInfographicBlockForm
          defaultBlockId={params.blockId}
        />
      </Box>
    </div>
  )
}

export default InfographicBlocksDetailsView
